import { Effect, put } from "redux-saga/effects";
import { ActivePhonesData } from "@sms/shared/active-phones/active-phones.interface";

import errorActions from "../error/error.actions";
import { apiCall } from "../utils/api-call";
import { FetchError } from "../utils/api-fetch";

import { setActivePhonesAction } from "./active-phones.actions";
import { activePhonesService } from "./active-phones.service";

export function* fetchActivePhones(): Generator<Effect | Generator, void, ActivePhonesData[]> {
  try {
    const activePhones: ActivePhonesData[] = yield apiCall(activePhonesService.getActivePhones);
    yield put(setActivePhonesAction(activePhones));
  } catch (e) {
    if (!(e instanceof FetchError) || e.status !== 401) {
      console.error(e);
      yield put(
        errorActions.setLocalErrorAction({
          message: e instanceof Error ? e.message : "Unknown error, while fetching user",
          details: e
        })
      );
    }
  }
}
